import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LandingHeader from "@/features/landing/LandingHeader";
import LandingHero from "@/features/landing/LandingHero";
import LandingStats from "@/features/landing/LandingStats";
import LandingPreview from "@/features/landing/LandingPreview";
import LandingFeatures from "@/features/landing/LandingFeatures";
import LandingHowItWorks from "@/features/landing/LandingHowItWorks";
import LandingFAQ from "@/features/landing/LandingFAQ";
import LandingCTA from "@/features/landing/LandingCTA";
import LandingFooter from "@/features/landing/LandingFooter";

/**
 * Marketing landing page, styled with the Vaulzo design system so it
 * looks like the same product as the dashboard. Each section lives in
 * its own component under `components/landing/`.
 */
export default function LandingPage() {
  const navigate = useNavigate();

  // Every CTA leads to the one-door auth page; the flow there decides
  // between sign-in and sign-up, so the mode argument is ignored.
  const openAuth = useCallback(() => navigate("/auth"), [navigate]);

  return (
    <div className="min-h-screen bg-vaulzo-bg text-vaulzo-ink">
      <LandingHeader onOpenAuth={openAuth} />

      <main>
        <LandingHero onOpenAuth={openAuth} />
        <LandingPreview />
        <LandingStats />
        <LandingFeatures />
        <LandingHowItWorks />
        <LandingFAQ />
        <LandingCTA onOpenAuth={openAuth} />
      </main>

      <LandingFooter />
    </div>
  );
}
